import { jsPDF } from "jspdf";
import moment from "moment";
import { defineStore, acceptHMRUpdate } from "pinia";

export const usePDF = defineStore("pdf", {
  state: () => ({}),
  getters: {},
  actions: {
    downloadPDF(downloadData, currentTransferName, depositedAt) {
      const el = document.createElement("div");
      let x = "";
      x = `
      <table>
        <tr>
          <td style="width:500px"></td>
          <td style="font-weight: bold">National Archives of Singapore (NAS)</td>
        </tr>
      </table>
      <table style="margin-bottom: 40px">
        <tr>
        <td style="width:580px"></td>
        <td style="font-weight: bold">Report Summary</td>
      </tr>
      </table>
    <table style="margin-bottom: 40px">
      <tr>
        <td style="width: 200px">Date Received by SDPS</td>
        <td>`;
      x += moment(depositedAt).format("DD MMM yyyy | HH:mm:ss");
      x += `</td>
      </tr>
      <tr>
        <td style="width: 200px">Transferring Agency</td>
        <td>`;
      x += downloadData.transferring_agency;
      x += `</td>
      </tr>
    </table>

    <table style="border: 1px solid black">
      <tr>
        <th style="width: 200px; text-align: left; border: 1px solid black">
          Transfer Batch
        </th>
        <th style="width: 200px; text-align: left; border: 1px solid black">
          Number of Items
        </th>
        <th style="width: 200px; text-align: left; border: 1px solid black">
          Total File Size (GB)
        </th>
        <th style="width: 200px; text-align: left; border: 1px solid black">
          Number of Errors
        </th>
        <th style="width: 200px; text-align: left; border: 1px solid black">
          Transfer Outcome
        </th>
      </tr>`;
      // for (let i = 0; i < downloadData.length; i++) {
      x += `<tr>`;
      if (!downloadData.transfer_batch_number) {
        x += `<td style="border: 1px solid black">-</td>`;
      } else {
        x += `<td style="border: 1px solid black">`;
        x += downloadData.transfer_batch_number;
        x += `</td>`;
      }
      if (downloadData.number_of_items == null) {
        x += `<td style="border: 1px solid black">0</td>`;
      } else {
        x += `<td style="border: 1px solid black">`;
        x += downloadData.number_of_items;
        x += `</td>`;
      }
      if (downloadData.total_size == null) {
        x += `<td style="border: 1px solid black">0</td>`;
      } else {
        x += `<td style="border: 1px solid black">`;
        x += formatSizeUnits(downloadData.total_size);
        x += `</td>`;
      }
      if (downloadData.number_of_errors == null) {
        x += `<td style="border: 1px solid black">0</td>`;
      } else {
        x += `<td style="border: 1px solid black">`;
        x += downloadData.number_of_errors;
        x += `</td>`;
      }
      if (downloadData.transfer_outcome == null) {
        x += `<td style="border: 1px solid black">-</td>`;
      } else {
        x += `<td style="border: 1px solid black">`;
        x += downloadData.transfer_outcome;
        x += `</td>`;
      }
      x += `</tr>`;
      // }
      x += `</table>
      <table style="margin-top: 40px">
      <tr>
        <td>
        Where the Transfer Outcome is "Failed", the Transferring Agency shall refer to the Error Report for a full list of errors and rectify them accordingly. 
        Once errors have been rectified, please schedule a new transfer. 
        Refer to the NAS Records Management website for more detailed transfer requirements and instructions.
        </td>
      </tr>
      <tr>
        <td style="padding-bottom: 10px">
        </td>
      </tr>
      <tr>
        <td style="padding-bottom: 30px">
        </td>
      </tr>
      <tr>
        <td style="padding-bottom: 30px">
          For any enquiries regarding this report, please email to
          NAS_RM@nlb.gov.sg.
        </td>
      </tr>
      <tr>
        <td style="font-style: italic">This is a computer generated report.</td>
      </tr>
    </table>

`;

      function formatSizeUnits(size) {
        if (size >= 1073741824) {
          size = (size / 1073741824).toFixed(2) + " GB";
        } else {
          size = (size / 1048576).toFixed(2) + " MB";
        }
        return size;
      }

      el.innerHTML = x;
      let doc = new jsPDF({
        orientation: "landscape",
      });
      el.style.width = "1400px";
      el.style.letterSpacing = "1px";

      doc.html(el, {
        callback: function (doc) {
          if (currentTransferName) {
            doc.save("Report Summary_" + currentTransferName + ".pdf");
          } else {
            doc.save("Report Summary.pdf");
          }
        },
        x: 4,
        y: 10,
        width: 1400,
        html2canvas: { scale: 0.2 },
      });

      // setTimeout(() => {
      //   //el.style.width = "100%";
      // }, 1000);
    },

    downloadPDFwithoutData(downloadData, currentTransferName, depositedAt) {
      const el = document.createElement("div");
      let x = "";
      x = `
      <table>
        <tr>
          <td style="width:500px"></td>
          <td style="font-weight: bold">National Archives of Singapore (NAS)</td>
        </tr>
      </table>
      <table style="margin-bottom: 40px">
        <tr>
          <td style="width:580px"></td>
          <td style="font-weight: bold">Report Summary</td>
        </tr>
      </table>
      <table style="margin-bottom: 40px">
      <tr>
        <td style="width: 200px">Date Received by SDPS</td>
        <td>`;
      x += moment(depositedAt).format("DD MMM yyyy | HH:mm:ss");
      x += `</td>
      </tr>
    </table>
    <table>
      <tr>
      The transfer package <b> "`;
      x += currentTransferName;
      x += `" </b>has been blocked and the Transfer Outcome is "Failed".
      <br>
      </tr>
    </table>

    <table style="margin-top: 40px">
      <tr>
        <td>
        Where the Transfer Outcome is "Failed", the Transferring Agency shall refer to the Error Report for a full list of errors and rectify them accordingly. 
        Once errors have been rectified, please schedule a new transfer. 
        Refer to the NAS Records Management website for more detailed transfer requirements and instructions.
        </td>
      </tr>
      <tr>
        <td style="padding-bottom: 10px">
        </td>
      </tr>
      <tr>
        <td style="padding-bottom: 30px">
        </td>
      </tr>
      <tr>
        <td style="padding-bottom: 30px">
          For any enquiries regarding this report, please email to
          NAS_RM@nlb.gov.sg.
        </td>
      </tr>
      <tr>
        <td style="font-style: italic">This is a computer generated report.</td>
      </tr>
    </table>`;

      el.innerHTML = x;
      let doc = new jsPDF({
        orientation: "landscape",
      });
      el.style.width = "1400px";
      el.style.letterSpacing = "1px";

      doc.html(el, {
        callback: function (doc) {
          if (currentTransferName) {
            doc.save("Report Summary_" + currentTransferName + ".pdf");
          } else {
            doc.save("Report Summary.pdf");
          }
        },
        x: 4,
        y: 10,
        width: 1400,
        html2canvas: { scale: 0.2 },
      });
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(usePDF, import.meta.hot));
}
